import { render, staticRenderFns } from "./OrderStatusDrop.vue?vue&type=template&id=04fe7082"
import script from "./OrderStatusDrop.vue?vue&type=script&lang=js"
export * from "./OrderStatusDrop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports